import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Tab } from 'semantic-ui-react';
import DatePicker, { registerLocale } from 'react-datepicker';
import vi from 'date-fns/locale/vi';
import InvoicePane from './InvoicePane';

import styles from './Invoices.module.scss';

const Invoices = React.memo(
  ({
    electricity,
    water,
    gas,
    isEditable,
    settingPrice,
    onFetchInvoicesElectricity,
    onFetchInvoicesGas,
    onFetchInvoicesWater,
  }) => {
    const [t] = useTranslation();
    registerLocale('vi', vi);

    const [invoiceElectricity, setInvoiceElectricity] = useState([]);
    const [invoiceWater, setInvoiceWater] = useState([]);
    const [invoiceGas, setInvoiceGas] = useState([]);

    useEffect(() => {
      const priceElectricity = electricity || [];
      const priceWater = water || [];
      const priceGas = gas || [];
      if (priceElectricity) setInvoiceElectricity(priceElectricity);
      if (priceWater) setInvoiceWater(priceWater);
      if (priceGas) setInvoiceGas(priceGas);
    }, [electricity, water, gas]);
    const panes = [
      {
        menuItem: t('common.settingPrice.electric'),
        render: () => (
          <InvoicePane
            isEditable={isEditable}
            key="electricity"
            defaultData={invoiceElectricity}
            settingPrice={settingPrice}
            name="electricity"
          />
        ),
      },
      {
        menuItem: t('common.settingPrice.water'),
        render: () => (
          <InvoicePane
            isEditable={isEditable}
            key="water"
            defaultData={invoiceWater}
            settingPrice={settingPrice}
            name="water"
          />
        ),
      },
      {
        menuItem: t('common.settingPrice.gas'),
        render: () => (
          <InvoicePane
            isEditable={isEditable}
            key="gas"
            defaultData={invoiceGas}
            settingPrice={settingPrice}
            name="gas"
          />
        ),
      },
    ];

    const dateFilterShowFormat = 'MM/yyyy';
    const dateFilterFormat = 'yMM';

    const [dateValue, setDateChange] = useState(new Date());
    const onDateChange = (value) => {
      setDateChange(value);
      if (value) {
        const datevalue = format(value, dateFilterFormat);
        onFetchInvoicesElectricity(datevalue);
        onFetchInvoicesWater(datevalue);
        onFetchInvoicesGas(datevalue);
      }
    };

    return (
      <div className={styles.invoicesWrapper}>
        <div className={styles.invoicesHeader}>
          <h2 className={styles.pageTitle}>{t('common.invoice')}</h2>
          <div className={styles.actionInvoices}>
            <DatePicker
              className={styles.datePicker}
              locale="vi"
              dateFormat={dateFilterShowFormat}
              showMonthYearPicker
              selected={dateValue}
              onChange={onDateChange}
            />
          </div>
        </div>
        <Tab panes={panes} />
      </div>
    );
  },
);

Invoices.propTypes = {
  electricity: PropTypes.arrayOf(PropTypes.any),
  water: PropTypes.arrayOf(PropTypes.any),
  gas: PropTypes.arrayOf(PropTypes.any),
  settingPrice: PropTypes.arrayOf(PropTypes.any),
  onFetchInvoicesElectricity: PropTypes.func.isRequired,
  onFetchInvoicesWater: PropTypes.func.isRequired,
  onFetchInvoicesGas: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
};

Invoices.defaultProps = {
  electricity: [],
  water: [],
  gas: [],
  settingPrice: [],
};

export default Invoices;
